import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Login from 'view/login';

const LoginPage = () => {
	return (
		<PageTemplate>
			<Login />
		</PageTemplate>
	);
};

export default LoginPage;